import { useState } from "react";
import { SelectOption } from "../constants/signup.types";
import SelectChip from "./SelectChip";
import { cn } from "../../../utils/css";

interface MultiSelectProps {
  options: SelectOption[];
  onChange: (values: any[]) => void;
  value?: string[];
}

const MultiSelect = ({ options, onChange, value = [] }: MultiSelectProps) => {
  const [selectedValues, setSelectedValues] = useState<string[]>(value);

  const handleMultiSelect = (option: SelectOption) => {
    const newSelectedValues = selectedValues.includes(option.id)
      ? selectedValues.filter((id) => id !== option.id)
      : [...selectedValues, option.id];

    setSelectedValues(newSelectedValues);
    onChange(
      newSelectedValues.map(
        (id) => options.find((opt) => opt.id === id)?.value,
      ),
    );
  };

  return (
    <div className="tw-relative">
      <div
        role="group"
        aria-label="Select options"
        className={cn("tw-flex tw-flex-col tw-gap-5 tw-w-full tw-items-center")}
      >
        {options.map((option: SelectOption) => (
          <SelectChip
            key={option.id}
            option={option}
            isSelected={selectedValues.includes(option.id)}
            onSelect={handleMultiSelect}
            ariaRole="checkbox"
          />
        ))}
      </div>
    </div>
  );
};

export default MultiSelect;
